<!-- Microinteraction (mi) Panel -->
<div class="one3d-mi-panel-wrapper">
  <div *ngIf="showTutorialForInterior" class="one3d-mi-tutorial-wrapper">
    <div class="one3d-mi-tutorial">
      <p class="one3d-mi-tutorial-para">
        {{ "MICRO_INTERACTION_PANEL.LOOK_EXTERIOR" | translate }}
        <strong
          >{{ "MICRO_INTERACTION_PANEL.INTERIOR_TXT" | translate }} !</strong
        >
      </p>
      <div class="one3d-mi-tutorial-close">
        <button (click)="closeInteriorTutorial()">
          <img
            src="assets/img/icons/one3d-plain-close-icon.svg"
            alt="close-icon"
          />
        </button>
      </div>
    </div>
  </div>
  <div class="one3d-mi-panel">
    <div class="one3d-mi-ext-int-btn">
      <div *ngIf="globalService.viewInterior">
        <button
          (click)="viewExterior()"
          class="one3d-mi-view-btn one3d-mi-ext-btn ion-hide-lg-down"
          [ngClass]="{
            activeButton: !globalService.viewInterior,
            nonActiveButton: globalService.viewInterior
          }"
          translate
        >
          MICRO_INTERACTION_PANEL.EXTERIOR
        </button>
        <button
          (click)="viewExterior()"
          class="one3d-mi-view-btn one3d-mi-ext-btn ion-hide-lg-up"
          [ngClass]="{
            activeButton: !globalService.viewInterior,
            nonActiveButton: globalService.viewInterior
          }"
          translate
        >
        <span >
          <img   src="assets/img/icons/one3d-ext-icon.svg" alt="exterior-icon">
        </span>
          MICRO_INTERACTION_PANEL.EXT
        </button>
      </div>
      <div *ngIf="!globalService.viewInterior">
        <button
          (click)="viewInterior()"
          class="one3d-mi-view-btn one3d-mi-int-btn ion-hide-lg-down"
          [ngClass]="{
            activeButton: globalService.viewInterior,
            nonActiveButton: !globalService.viewInterior
          }"
          translate
        >
          MICRO_INTERACTION_PANEL.INTERIOR
        </button>
        <button
          (click)="viewInterior()"
          class="one3d-mi-view-btn one3d-mi-int-btn ion-hide-lg-up"
          [ngClass]="{
            activeButton: globalService.viewInterior,
            nonActiveButton: !globalService.viewInterior
          }"
          translate
        >
        <span >
          <img   src="assets/img/icons/one3d-int-icon.svg" alt="interior-icon">
        </span>
          MICRO_INTERACTION_PANEL.INT
        </button>
      </div>
    </div>
    <div
      (click)="
        !globalService.viewInterior
          ? hideShowColorPallette()
          : hideShowTrimPallette()
      "
      *ngIf="
        selectedVariant?.trims.length > 0 ? true : !globalService.viewInterior
      "
      class="one3d-mi-panel-element"
      [ngClass]="{ 'one3d-rotate-img': globalService.idea != 0 }"
    >
      <img src="assets/img/icons/one3d-color-palette-icon.svg" alt="color" />
      <span translate>MICRO_INTERACTION_PANEL.COLORS</span>
    </div>
    <div
      *ngIf="selectedVariant?.backgrounds.length > 0"
      class="one3d-mi-panel-element"
      [ngClass]="{ 'one3d-rotate-img': globalService.idea != 0 }"
      (click)="backgroundChange()"
    >
      <img [src]="backGroundImage" alt="bg" />
      <span translate>MICRO_INTERACTION_PANEL.BACKGROUNDS</span>
    </div>
    <div
      class="one3d-mi-panel-element"
      *ngFor="let interaction of microInteractions"
      (click)="microInteraction3DCall(interaction)"
      [ngClass]="{
        'one3d-display-none': globalService.viewInterior && interaction.id == 2,
        'one3d-rotate-img': globalService.idea != 0
      }"
    >
      <img
        [src]="interaction.icon"
        color="primary"
        alt="icons"
        *ngIf="!(globalService.viewInterior && interaction.id == 2)"
      />
      <span *ngIf="!(globalService.viewInterior && interaction.id == 2)">
        {{ interaction.interaction_type }}
      </span>
    </div>
  </div>
  <div
    *ngIf="
      globalService.viewInterior && (selectedVariant.num_of_seats == '5 Seater' || selectedVariant.num_of_seats === '4 Seater')
    "
    class="one3d-seating-rows-wrapper one3d-visualizer-seating-rows"
  >
    <ion-select
      interface="popover"
      placeholder="Seating Rows - 1st Row"
      class="one3d-seating-rows"
      [value]="seatingView"
      (ionChange)="viewSeats($event, fromCallBack)"
      mode="md"
      [selectedText]="
        seatingView == 'frontSeatView'
          ? 'Seating Rows - 1st Row'
          : seatingView == 'backSeatView'
          ? 'Seating Rows - 2nd Row'
          : 'Seating Rows - 3rd Row'
      "
    >
      <ion-select-option value="frontSeatView" translate
        >MICRO_INTERACTION_PANEL.1ST_ROW_SEATS</ion-select-option
      >
      <ion-select-option value="backSeatView" translate
        >MICRO_INTERACTION_PANEL.2ND_ROW_SEATS</ion-select-option
      >
    </ion-select>
  </div>
  <div
    *ngIf="
      globalService.viewInterior && selectedVariant.num_of_seats == '7 Seater'
    "
    class="one3d-seating-rows-wrapper one3d-visualizer-seating-rows"
  >
    <ion-select
      interface="popover"
      placeholder="Seating Rows - 1st Row"
      class="one3d-seating-rows"
      [value]="seatingView"
      (ionChange)="viewSeats($event, fromCallBack)"
      mode="md"
      [selectedText]="
        seatingView == 'frontSeatView'
          ? 'Seating Rows - 1st Row'
          : seatingView == 'backSeatView'
          ? 'Seating Rows - 2nd Row'
          : 'Seating Rows - 3rd Row'
      "
    >
      <ion-select-option value="frontSeatView" translate
        >MICRO_INTERACTION_PANEL.1ST_ROW_SEATS</ion-select-option
      >
      <ion-select-option value="backSeatView" translate
        >MICRO_INTERACTION_PANEL.2ND_ROW_SEATS</ion-select-option
      >
      <ion-select-option value="lastSeatView" translate
        >MICRO_INTERACTION_PANEL.3RD_ROW_SEATS</ion-select-option
      >
    </ion-select>
  </div>
  <!-- new-seating-rows-design for mobile -->
  <div class="one3d-mobile-seating-config">
    <ion-fab
      class="one3d-mobile-seat-rows"
      slot="fixed"
      vertical="top"
      horizontal="start"
      *ngIf="
        globalService.viewInterior &&
        (selectedVariant.num_of_seats=== '5 Seater' || selectedVariant.num_of_seats === '4 Seater')
      "
    >
      <ion-fab-button class="one3d-mobile-seat-rows-toggle">
        <img src="assets/img/icons/one3d-seat-rows.svg" alt="seat rows" />
      </ion-fab-button>
      <ion-fab-list side="start">
        <ion-fab-button (click)="viewSeatsMobile('backSeatView')">
          <ion-text class="ion-text-center fs-12 one3d-color-black">
            <strong class="d-block fw-800">2nd</strong>
            <span class="d-block">row</span>
          </ion-text>
        </ion-fab-button>
        <ion-fab-button (click)="viewSeatsMobile('frontSeatView')">
          <ion-text class="ion-text-center fs-12 one3d-color-black">
            <strong class="d-block fw-800">1st</strong>
            <span class="d-block">row</span>
          </ion-text>
        </ion-fab-button>
      </ion-fab-list>
    </ion-fab>
    <ion-fab
      class="one3d-mobile-seat-rows"
      slot="fixed"
      vertical="top"
      horizontal="start"
      *ngIf="globalService.viewInterior && selectedVariant.num_of_seats=== '7 Seater'"
    >
      <ion-fab-button class="one3d-mobile-seat-rows-toggle">
        <img src="assets/img/icons/one3d-seat-rows.svg" alt="seat rows" />
      </ion-fab-button>
      <ion-fab-list side="start">
        <ion-fab-button (click)="viewSeatsMobile('lastSeatView')">
          <ion-text class="ion-text-center fs-12 one3d-color-black">
            <strong class="d-block fw-800">3rd</strong>
            <span class="d-block">row</span>
          </ion-text>
        </ion-fab-button>
        <ion-fab-button (click)="viewSeatsMobile('backSeatView')">
          <ion-text class="ion-text-center fs-12 one3d-color-black">
            <strong class="d-block fw-800">2nd</strong>
            <span class="d-block">row</span>
          </ion-text>
        </ion-fab-button>
        <ion-fab-button (click)="viewSeatsMobile('frontSeatView')">
          <ion-text class="ion-text-center fs-12 one3d-color-black">
            <strong class="d-block fw-800">1st</strong>
            <span class="d-block">row</span>
          </ion-text>
        </ion-fab-button>
      </ion-fab-list>
    </ion-fab>
  </div>
</div>
